<template>
  <div @click="routerTo" class="ac-img">
    <img :src="info.img">
  </div>
</template>
<script>
export default {
  props: {
    info: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    routerTo () {
      // const href = this.info.href.split('/#')
      this.$router.push({ path: this.info.href });
    }
  }
}
</script>
<style lang="scss" scoped>
.ac-img{
  width: 7.18rem;
  margin: auto;
  display: block;
}
</style>